module.exports = "/_next/static/images/345d57822772ba8e98fe501362a68b4c-join-us-xs-1x.png.webp";